import { userConstants } from './../constants/user.constants';

const initialState = {};

export function Getaadharback(state = initialState, action) {
  
  //
  switch (action.type) {
    case userConstants.GETAADHARBACK_REQUEST:
      return {
        user: action.user,
        isLoading : true

      };
    case userConstants.GETAADHARBACK_SUCCESS:
      const {res} = action
        
      return {
        res,
        isLoading : false
      };
    case userConstants.GETAADHARBACK_FAILURE:
      return {
        isLoading : false
      };
    default:
      return state
  }
}